import React from "react";
import { ELON_PHOTO_URL } from "../../lib/memeData";

export const KingOfRetards = () => {
  return (
    <section className="px-5 md:px-10 py-14" data-testid="king-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <p className="font-display text-2xl md:text-3xl text-[#E8742C]">
            ⚜️ all hail ⚜️
          </p>
          <h2 className="font-display text-5xl md:text-7xl lg:text-8xl">
            king of the <span className="text-[#E8742C]">retards</span> 👑
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-8 md:gap-12 items-center">
          {/* Elon portrait card */}
          <div className="relative wiggle">
            <div className="crayon-card p-4 rotate-[-3deg]">
              <span className="tape" style={{ background: "rgba(232, 116, 44, 0.6)" }} />
              <div className="relative aspect-square w-full border-4 border-[#1A1A1A] bg-[#FFF5E5] overflow-hidden">
                {ELON_PHOTO_URL ? (
                  <img
                    src={ELON_PHOTO_URL}
                    alt="Elon Musk — King of the Retards"
                    className="w-full h-full object-cover"
                    data-testid="elon-photo"
                  />
                ) : (
                  <div
                    className="w-full h-full flex flex-col items-center justify-center text-center px-6"
                    data-testid="elon-placeholder"
                  >
                    <div className="text-7xl md:text-8xl">👑</div>
                    <p className="font-display text-2xl md:text-3xl mt-3 text-[#1A1A1A]">
                      elon goes here
                    </p>
                    <p className="text-sm md:text-base text-[#1A1A1A]/60 mt-1">
                      drop a pic into <code>ELON_PHOTO_URL</code>
                      <br />
                      in <code>src/lib/memeData.js</code>
                    </p>
                  </div>
                )}
              </div>
              <p className="font-display text-center text-2xl md:text-3xl mt-3 text-[#1A1A1A]">
                Elon Musk
              </p>
            </div>
            <span
              className="sticker"
              style={{
                top: "-18px",
                right: "-12px",
                background: "#E63946",
                color: "white",
                transform: "rotate(8deg)",
              }}
            >
              the chosen one
            </span>
          </div>

          {/* The lore */}
          <div className="crayon-card-soft p-6 md:p-8 rotate-1">
            <p className="text-xl md:text-2xl leading-relaxed text-[#1A1A1A]">
              richest man on earth. owns X. runs DOGE. shoots cars into space for
              fun. tweets at 4am. flamethrowers, rockets, robots, dogecoin.
              <br />
              <br />
              if anyone deserves the propeller hat, it's <b>him</b>.
              <br />
              <br />
              he bought twitter for <b className="text-[#E8742C]">$44 billion</b> as a joke.
              we're buying $RETARD. who's really the retard here? 🤷
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="sticker" style={{ position: "static", transform: "rotate(-2deg)" }}>
                certified king
              </span>
              <span
                className="sticker"
                style={{
                  position: "static",
                  transform: "rotate(2deg)",
                  background: "#2A9D8F",
                  color: "white",
                }}
              >
                propeller approved
              </span>
              <span
                className="sticker"
                style={{
                  position: "static",
                  transform: "rotate(-1deg)",
                  background: "#457B9D",
                  color: "white",
                }}
              >
                tweet at us elon
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KingOfRetards;
